<template>
  <div class="common-account-select-wrapper">
    <div class="common-account-select-left">
      <account-select-item v-for="(contact, index) in contacts" :key="index" v-if="contact.im_accid !== imAccount.im_accid" :contact="contact" :check-list.sync="checkList" />
    </div>
    <account-select-item-show :title="title" :check-list="checkList">
      <template v-slot:check-users-operate="{ disable }">
        <team-member-operate :operate-name="operateName" :disable="disable" @cancel="clearData" @operate="operate" />
      </template>
    </account-select-item-show>
  </div>
</template>

<script>
import AccountSelectItem from './AccountSelectItem'
import AccountSelectItemShow from './AccountSelectItemShow'
import TeamMemberOperate from './create/TeamMemberOperate'
import { mapState } from 'vuex'

export default {
  name: 'AccountSelectWrapper',
  components: {
    AccountSelectItem,
    AccountSelectItemShow,
    TeamMemberOperate
  },
  props: {
    contacts: {
      type: Array,
      default: () => {
        return []
      }
    },
    type: {
      type: String,
      default: 'create'
    }
  },
  data () {
    return {
      contactData: [],
      checkList: []
    }
  },
  computed: {
    ...mapState({
      imAccount: state => state.imAccount
    }),
    title () {
      let title = ''
      if (this.type === 'create') {
        title = '发起群聊'
      } else if (this.type === 'add') {
        title = '添加成员'
      } else {
        title = '移出成员'
      }

      return title
    },
    operateName () {
      let name = ''
      if (this.type === 'create') {
        name = '创建'
      } else if (this.type === 'add') {
        name = '完成'
      } else {
        name = '完成'
      }

      return name
    }
  },
  watch: {
  },
  methods: {
    clearData () {
      this.checkList = []
      console.log('this.type', this.type)
      if (this.type === 'create') {
        this.$store.dispatch('changeImWinCreateTeamVisibleAction', false)
      } else if (this.type === 'add') {
        this.$store.dispatch('changeImTeamMemberAddVisibleAction', false)
      } else {
        console.log('???')
        this.$store.dispatch('changeImTeamMemberRemoveVisibleAction', false)
      }
    },
    operate () {
      this.$emit('operate', this.checkList)
    }
  }
}
</script>

<style lang="stylus" scoped>
.common-account-select-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
}
.common-account-select-left {
  flex: 1;
  padding: 10px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/common/im/team/AccountSelectWrapper.vue